import axios, { type AxiosInstance } from 'axios'
import { setupAxiosInterceptors } from './axiosInterceptors'
import { getApiBaseUrl } from '../config/environment'

/**
 * Axios instance configured with environment-specific base URL
 * Uses centralized environment configuration - no hardcoded URLs
 */
const axiosInstance: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 300000, // Increase to 5 minutes (300 seconds)
  withCredentials: true,
  maxContentLength: 100 * 1024 * 1024, // 100MB
  maxBodyLength: 100 * 1024 * 1024, // 100MB
})

setupAxiosInterceptors(axiosInstance)

// Make axios instance available globally for activity tracking
if (typeof window !== 'undefined') {
  (window as any).axios = axiosInstance
  // Log for debugging
  console.log(`🔗 API Base URL: ${axiosInstance.defaults.baseURL}`)
  console.log(`🍪 With Credentials: ${axiosInstance.defaults.withCredentials}`) // ADD THIS LOG
}

export default axiosInstance